import React from "react";
import { Popover, Timeline, Comment } from "antd";
import type { TaskEvaluation } from "@/employee_tasks/types/task";
import moment from "moment";
import { PeopleCardTag } from "../../../tmcard/styles";

export const EvaluationHistory: React.FC<{
  currentEval?: TaskEvaluation;
  evaluationHistory: TaskEvaluation[];
  children: any;
}> = ({ currentEval, evaluationHistory, children }) => {
  if (currentEval)
    return (
      <Popover
        placement="left"
        content={
          <div style={{ width: 250 }}>
            <Timeline mode="left">
              {evaluationHistory.map((item, index) => (
                <Timeline.Item
                  color={index === 0 ? "green" : "blue"}
                  key={item.id}
                  label={
                    <>
                      <b>{moment(item.evaluated_at).format("DD/MM/YYYY")}</b>
                      <br />
                      {item.evaluation_option && (
                        <PeopleCardTag
                          textColor={item.evaluation_option.color_text}
                          color={item.evaluation_option.color_tag}
                        >
                          {item.evaluation_option.name}
                        </PeopleCardTag>
                      )}
                      {!item.evaluation_option && (
                        <PeopleCardTag color="grey">Limpo</PeopleCardTag>
                      )}
                    </>
                  }
                >
                  <Comment
                    author={
                      item.evaluator_user.first_name &&
                      item.evaluator_user.last_name
                        ? `${item.evaluator_user.first_name} ${item.evaluator_user.last_name}`
                        : item.evaluator_user.username
                    }
                    content={undefined}
                  />
                </Timeline.Item>
              ))}
            </Timeline>
          </div>
        }
      >
        {children}
      </Popover>
    );
  return children;
};
